import React from "react";
import ChatBot from "./Chat";

function App() {
  return <ChatBot />;
}

export default App;
